import { createSelector } from '@ngrx/store';
import { geolocationState } from '../root';

export const getGeolocationState = createSelector(geolocationState, (geolocation) => geolocation);
